import { Component, Input, Inject, OnInit } from '@angular/core';

import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./../models/types";
import { GroupService } from '../../../../../admin/services/group.service';
import { Observable } from 'rxjs';
import { GroupStub } from '../../../../../admin/models/group.model';
import { first } from 'rxjs/operators';

@Component({
    selector: 'cancel-org',
    templateUrl: './side-effect-cancel-org.component.html',
    standalone: false
})
export class SideEffectCancelOrgComponent implements OnInit {
    _seConfiguration: any;
    availableGroups = new Array<GroupStub>();

    set seConfiguration(value: any) {
        this._seConfiguration = value ||{};
        this._seConfiguration.organizationId = this._seConfiguration.organizationId||''; 
        this._seConfiguration.groupIdToAssignUsersTo = this._seConfiguration.groupIdToAssignUsersTo || '';               
    }

    get seConfiguration(): any {
        return this._seConfiguration;
    }
    
    constructor(
        public readonly groupService: GroupService,
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData
    ) {
        this.seConfiguration = data.configuration;
    }

    ngOnInit() {
        this.getAvailableGroups();
    }

    getAvailableGroups(): void {
        this.availableGroups.push({ id: "-1", displayName: "..." });
        (this.groupService.get({ stubs: true, internal: false }) as Observable<GroupStub[]>).pipe(
            first())
            .subscribe(groups => {
                this.availableGroups = this.availableGroups.concat(groups);
            });
    }
}
